import React from 'react';
import classnames from 'classnames';

import styles from './header.scss';

const Header = ({children, size}) => (
  <header className={classnames(styles.header, styles[size])}>
    {children}
  </header>
);

export { Header };



// WEBPACK FOOTER //
// ./src/components/header/header.js